export const NAME = 'indexTabElements';
